import React, { useEffect, useState, useRef, useContext } from 'react';
import { useSwipeGesture } from '../../hooks/useSwipeGesture';
import analizeRideStatus from '../../utils/analizeRideStatus';
import BookerContext from '../../context/bookerContext';
import BookerShortContext from '../../context/bookerShortContext';
import DriverInfo from '../RideComponents/DriverInfo';
import AddressInfo from '../RideComponents/AddressInfo';
import CancelRide from '../RideComponents/CancelRide';
import SupportEmail from './SupportEmail';
import '../../assets/styles/slide-up-screen.sass';

const SlideUpScreen = () => {
  const { state: { accountCreation } = {} } = useContext(BookerContext);
  const { ride, setResetMapHeight } = useContext(BookerShortContext);
  const { state: rideStatus, vehicle_number, eta } = ride || {};
  const { etaMessage } = analizeRideStatus(rideStatus, eta);

  const [isOpen, setIsOpen] = useState(false);
  const slideUpScreen = useRef(null);

  const toggleSlider = nextState => {
    setIsOpen(typeof nextState === 'boolean' ? nextState : !isOpen);
  };

  const [setIsZoneOpened, setSwipedZone] = useSwipeGesture({
    zone: slideUpScreen?.current,
    exceptionZoneList: {
      custom: ['toggle-btn'],
      click: ['chat-btn', 'phone-btn', 'support-email', 'cancel-ride-btn'],
    },
    toggleHandler: toggleSlider,
  });

  useEffect(() => {
    if (!slideUpScreen?.current) return;
    setSwipedZone(slideUpScreen?.current);
  }, [slideUpScreen?.current, setSwipedZone]);

  useEffect(() => {
    setResetMapHeight(isOpen);
    setIsZoneOpened(isOpen);
  }, [isOpen, setIsZoneOpened, setResetMapHeight]);

  if (!(ride && rideStatus !== 'enroute' && !accountCreation?.flow)) return <></>;

  return (
    <div ref={slideUpScreen} className={`slide-up-container ${isOpen ? 'open' : ''}`}>
      <div className="slide-up-screen">
        <div className="toggle-btn" onClick={toggleSlider} />
        {(etaMessage || vehicle_number) && (
          <div className="details-wrapper">
            <div className="ride-eta">{etaMessage}</div>
            <DriverInfo />
          </div>
        )}
      </div>
      {isOpen && (
        <>
          <AddressInfo />
          {vehicle_number && <SupportEmail />}
          <CancelRide />
        </>
      )}
    </div>
  );
};

export default SlideUpScreen;
